export const THE_ORG_ID = 34;
const SUPER_PERMISSION_EMAILS = [
  'dave@expeditiondata.com',
  'carlos@expeditiondata.com',
  'ed@expeditiondata.com',
  'ian.forsyth@teamengine.io',
  'danny.laurence@thehiringengine.com',
];

/*
This is used in a few places - customer lists and customer pages
to make sure that we don't show Team Engine customer to
employees so they can see evaluations of themselves or others.
 */
export const hasPermissionIfTHE = (orgId: number, user: { email: string }) => {
  if (orgId !== THE_ORG_ID) {
    return true;
  }

  return SUPER_PERMISSION_EMAILS.find((e) => e === user.email);
};
